import axios, { AxiosError, AxiosResponse } from 'axios';
import { GenericObject } from 'core/models/platform';
// import getConfig from 'next/config';
import { httpPost } from 'core/utils/httpClient';
import { CrossrefSearchApiResponse } from 'src/citation-generator/types/crossref';
import { CitationSourceEnum } from '../types';
import { isDoi } from '../utils';

// const { publicRuntimeConfig } = getConfig();
// const appVersion = `${publicRuntimeConfig.APP_VERSION}`;
const contactEmail = 'co-writer@quillbot.com';
const crossrefInstance = axios.create({
  baseURL: 'https://api.crossref.org',
  timeout: 15000,
  // headers: {
  //   'user-agent': `QuillBot/Citation-Generator/${appVersion} (https://quillbot.com/citation-generator; mailto:${contactEmail})`,
  // },
  timeoutErrorMessage: 'That took too long. Please try searching with a more specific query.',
});
crossrefInstance.interceptors.response.use(undefined, (error: AxiosError) =>
  Promise.reject(
    error.response?.status === 404 ? 'Resource not found' : error.response?.data || error.message
  )
);

export const PUBLICATION_ITEM_TYPES: Record<CitationSourceEnum, string> = {
  Book: 'book',
  Journal: 'jrnl',
  Website: 'web',
  // Archive: 'archv',
};

export const bibSearchApi = ({
  query,
  page,
  publicationType,
}: {
  query: string;
  page: number;
  publicationType: CitationSourceEnum;
}) =>
  httpPost('/utils/bib-search', {
    query,
    page,
    publicationItemType: PUBLICATION_ITEM_TYPES[publicationType],
  });

export const crossrefSearchApi = ({
  query,
  page,
  noOfResults = 10,
  sortBy,
}: {
  query: string;
  page: number;
  noOfResults?: number;
  sortBy?: string;
}) => {
  let path = '';
  const params: GenericObject = {
    mailto: contactEmail,
  };

  if (isDoi(query)) {
    path = `works/${query}`;
  } else {
    path = 'types/journal-article/works';
    params['query.bibliographic'] = query;
    params.rows = noOfResults;
    params.offset = noOfResults * (page - 1);
    if (sortBy) {
      params.sort = sortBy;
    }
  }

  return crossrefInstance
    .get(path, { params })
    .then((res: AxiosResponse): CrossrefSearchApiResponse => {
      /**
       * res @type {
       *  status: string;
       *  'message-type': string;
       *  'message-version': string;
       *  message: {
       *    facets: {};
       *    'items-per-page': number;
       *    items: Array<CrossrefItem>;
       *    'items-per-page': number;
       *    query: {
       *      'start-index': number;
       *      'search-terms': null | string;
       *    };
       *  }
       * }
       */
      if (Array.isArray(res.data.message?.items)) {
        return {
          items: res.data.message.items,
          'total-results': res.data.message['total-results'],
          'items-per-page': res.data.message['items-per-page'],
          query: res.data.message.query,
        };
      }

      return {
        items: [res.data.message],
        'total-results': 1,
        'items-per-page': 1,
      };
    });
};
